import { CurationPhase } from '@/stores/CreateCurationStore';
import type { Product } from '@/types/Product.types';

export interface DraggableProductItemProps {
  product: Product;
  isReplacing: boolean;
  hasHistory: boolean;
  historyCount: number;
  rank: number | undefined;
  isSelected: boolean;
  isInDragGroup: boolean;
  onRestore: (p: Product) => void;
  onReplace: (p: Product) => void;
  onRemove: (id: number) => void;
  onToggleSelection: (id: number) => void;
}

export const PHASE_LABELS: Record<CurationPhase, string> = {
  [CurationPhase.UPLOAD]: 'Upload',
  [CurationPhase.SELECT]: 'Select',
  [CurationPhase.REVIEW]: 'Review',
  [CurationPhase.FINALIZE]: 'Finalize',
};

export const PHASE_ORDER: CurationPhase[] = [
  CurationPhase.UPLOAD,
  CurationPhase.SELECT,
  CurationPhase.REVIEW,
  CurationPhase.FINALIZE,
];

export const REPLACEMENT_HISTORY_SAVE_DEBOUNCE_MS = 1000;
